import type { BadgeId, SeasonState } from "../types";
import { BADGES } from "../data/badges";

/** Badge ids that just reached their target this season and aren't unlocked yet. */
export function checkBadges(unlocked: readonly BadgeId[], s: SeasonState): BadgeId[] {
  return BADGES.filter((b) => !unlocked.includes(b.id) && b.progress(s) >= b.target).map((b) => b.id);
}
